import { render } from "./BenignSection.vue?vue&type=template&id=3c41f928"
import script from "./BenignSection.vue?vue&type=script&lang=js"
export * from "./BenignSection.vue?vue&type=script&lang=js"

import "./BenignSection.vue?vue&type=style&index=0&id=3c41f928&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__